"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var actions_1 = __importDefault(require("../../actions"));
var useStyles = (0, core_1.makeStyles)(function (theme) {
    return (0, core_1.createStyles)({
        createButton: {
            width: 150,
            height: 44,
            marginTop: theme.spacing(4),
        },
    });
});
function CreateButton(_a) {
    var className = _a.className;
    var classes = useStyles();
    var dispatch = (0, react_redux_1.useDispatch)();
    var openCreateUrlModal = function () { return dispatch(actions_1.default.openCreateUrlModal()); };
    return (react_1.default.createElement(core_1.Button, { size: "large", color: "primary", variant: "contained", onClick: openCreateUrlModal, className: (0, classnames_1.default)(className, classes.createButton) }, "Create link"));
}
exports.default = CreateButton;
